import React from 'react';
import OrganizeManagementRouter from './OrganizeManagementRouter';

export default function OrganizeManagementPage() {
  return <OrganizeManagementRouter />;
}
